export const DURATION_SPACER = "DURATION_SPACER";
export const DURATION_YEARS = "DURATION_YEARS";
export const DURATION_MONTHS = "DURATION_MONTHS";
export const DURATION_WEEKS = "DURATION_WEEKS";
export const DURATION_DAYS = "DURATION_DAYS";
